import { Container, Card, Button } from 'react-bootstrap';
import CalendarView from '../components/CalendarViews'; 

const AuctionPage = () => {
    // 1. SUMBER DATA UTAMA: Atur semua jadwal lelang di sini.
    // Inget sisan: Bulan di JavaScript dimulai dari 0 (Januari=0, Desember=11)
    const auctionData = [
        { date: new Date(2025, 7, 17), title: 'Syailendra Auction #1', description: 'Lelang Perdana! Lot Tjiamik Pol🔥' },
        { date: new Date(2025, 9, 15), title: 'FUN COLLECT & COMPLETE #9', description: 'Tiap Lot Tjiamik Pol🔥' },
        { date: new Date(2025, 9, 16), title: 'COMPLETE & MUST HAVE #9', description: 'Tiap Lot Tjiamik Pol🔥' },
        { date: new Date(2025, 9, 19), title: 'MUST HAVE & PRESTIGE #9', description: 'Tiap Lot Tjiamik Pol🔥' },
        // { date: new Date(2025, 9, 5), title: 'PRESTIGE #7', description: 'Item Complete tiap Lot Tjiamik Pol🔥' },
        // TAMBAHKAN JADWAL BERIKUT NYA DI SINI YA YUDHA JANGAN BINGUNG CARI LAGI!
    ];

    // 2. Fungsi untuk otomatis mencari lelang terdekat dari hari ini.
    const findNextAuction = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Reset waktu untuk perbandingan tanggal yang akurat

        const upcomingAuctions = auctionData.filter(auction => auction.date >= today);

        if (upcomingAuctions.length === 0) {
            return {
                title: "Nantikan Jadwal Berikutnya",
                date: "Belum ada jadwal lelang yang akan datang."
            };
        }
        upcomingAuctions.sort((a, b) => a.date - b.date); // Urutkan untuk dapat yang paling dekat
        const next = upcomingAuctions[0];

        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = next.date.toLocaleDateString('id-ID', options);

        return {
            title: next.description,
            date: formattedDate
        };
    };
    
    const nextAuction = findNextAuction();

    // 3. Menyiapkan data untuk dikirim ke komponen Kalender
    const prepareEventsForCalendar = () => {
        const events = {};
        auctionData.forEach(auction => {
            const year = auction.date.getFullYear();
            const month = auction.date.getMonth();
            const day = auction.date.getDate();

            if (!events[year]) events[year] = {};
            if (!events[year][month]) events[year][month] = {};
            
            events[year][month][day] = auction.title;
        });
        return events;
    };

    const calendarEvents = prepareEventsForCalendar();

    return (
        <div className="py-5" style={{ backgroundColor: '#f0efe9' }}>
            <Container>
                <div className="text-center mb-5">
                    <h1 className="display-4" style={{ fontFamily: 'Cinzel, serif' }}>Kalender Lelang</h1>
                    <p className="lead" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Lihat jadwal lelang kami yang akan datang.
                    </p>
                </div>

                 {/* Kartu ini sekarang otomatis mengambil data dari lelang terdekat */}
                <Card className="text-center mb-5 shadow">
                    <Card.Header as="h5">Lelang Berikutnya</Card.Header>
                    <Card.Body>
                        <Card.Title>{nextAuction.title}</Card.Title>
                        <Card.Text>
                            Jadwal lelang terdekat akan dimulai pada: <br/>
                            <strong>{nextAuction.date}</strong>
                        </Card.Text>
                        <Button variant="dark" href="https://bid.syailendra-auction.com/">Lihat Katalog</Button>
                    </Card.Body>
                </Card>
                
                {/* 4. Mengirim data lelang ke komponen Kalender */}
                <CalendarView events={calendarEvents} />

            </Container>
        </div>
    );
}

export default AuctionPage;

